/**
 * Common module for client side libraries shared across the
 * different node-react apps within NerdWallet.
 *
 * @module
 */
import Tracking from './tracking';
import AB from './react-redux-ab-modules';
import Num from './num';
import logger from './logging';
/**
 * Tracking client lib module to enable analytic events on NW's apps.
 *
 * @module
 */

export { Tracking };
/**
 * AB module to integrate react and redux with internal AB / Optimizely
 *
 * @module
 */

export { AB };
export { Num };
export { logger };
export default {
  Tracking: Tracking,
  AB: AB,
  Num: Num,
  logger: logger
};